'use strict'

const wrongPhone = $('#easyForm #form-phone-error');

$(document).ready(function() {
    // Function to check if all required inputs and selects within #easyForm are filled
    function checkFormCompletion() {
        let allFilled = true;

        // Check all required inputs within #easyForm
        $('#easyForm .js-form-control-storeApp').each(function() {
            if ($(this).val() === '') {
                allFilled = false;
                return false; // Break out of the loop
            }
        });

        // Enable or disable the submit button based on the allFilled variable
        if (allFilled && !wrongPhone.hasClass('d-block')) {
            $('#easyForm .js-easyFormBtn').removeAttr('disabled');
        } else {
            $('#easyForm .js-easyFormBtn').attr('disabled', 'disabled');
        }
    }
    
    if(wrongPhone.hasClass('d-block')){
        $('#easyForm .js-easyFormBtn').attr('disabled', 'disabled');
    }

    // Bind the checkFormCompletion function to input and change events within #easyForm
    $('#easyForm input, #easyForm select[required]').on('input change', checkFormCompletion);

    // Initial check to set the submit button state on page load
    checkFormCompletion();
});

/* SEARCH INPUT VALIDATION */
$(document).ready(function() {
    // Function to check if the input is not empty and enable/disable the button
    function validateInput() {
        let inputVal = $('#storeAppSearchForm #searchInput').val();
        if (inputVal.trim() !== '') {
            $('#storeAppSearchForm .js-search-customer-btn').removeAttr('disabled');
        } else {
            $('#storeAppSearchForm .js-search-customer-btn').attr('disabled', 'disabled');
        }
    }

    // Bind the validateInput function to input events on the search input
    $('#storeAppSearchForm #searchInput').on('input', validateInput);

    // Initial check to set the button state on page load
    validateInput();
});
